import React from 'react'
import { Button, Image, Modal, Row, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

export const SuccessModal = ({showSuccessModal, setShowSuccessModal}) => {
    const handleCloseModal = () => setShowSuccessModal(false);
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        handleCloseModal();
        navigate(path, { replace: true });
    };

    return (
        <Modal
            show={showSuccessModal}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            size="sm"
            centered
        >
            <Modal.Body>
                <div className="text-center px-4 pt-4">
                    <Image src='/images/icon-modal-success.svg' className='mx-auto' />
                    <h5 className='fw-bold mt-4'>Consent uploaded</h5>
                    <p className='mb-5'>You have successfully uploaded the consent </p>
                </div>
            </Modal.Body>
            <Modal.Footer className='border-0 px-4 pb-4'>
                <Row className="w-100">
                    <Col xs={12} className="mb-2">
                        <Button
                            variant="dark"
                            className='w-100'
                            onClick={() => handleNavigation('/new-consent')}
                        >
                            Submit Another Consent
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <Button
                            variant="outline-dark"
                            className='w-100'
                            onClick={() => handleNavigation('/manage-consent')}
                        >
                            Manage Consent
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}